import axios from 'axios';
import useAgent from '../../../hooks/useAgent';

const getItemSealHistory = (inventoryId, itemId) => axios.get(`/api/v1/inventory/${inventoryId}/inventory-items/${itemId}/seal-history`);

export const useGetItemSealHistory = () => useAgent(getItemSealHistory);
